<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="posting()"><i class="fa fa-upload"></i> Posting</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"
            ><i class="fa fa-file-excel-o"></i> Export</b-button
          >
        </div>
      </div>
      <b-row>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode Trx.</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text"
                >until</span
              ></b-input-group-prepend
            >
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
                <label>Project</label>
              </b-input-group-prepend>
              <b-form-select v-model="tblData.pjxkey" :plain="true" :options="projectsFilt"></b-form-select>  
            <b-button class="btn btn-success ml-3" @click="refresh()">
              <i class="fa fa-refresh"></i> Apply
            </b-button>
            <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
              <i class="fa fa-eraser"></i>Clear
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        @row-dblclicked="rowDblClicked"
        :busy="isBusy"
        show-empty
      >
        <template v-slot:cell(index)="data">{{
          (tblData.page - 1) * tblData.limit + (data.index + 1)
        }}</template>
        <template v-slot:cell(repayment_date)="data">{{
          data.item.repayment_date | moment("YYYY MMM DD")
        }}</template>
        <template v-slot:cell(count_trx)="data">{{
          data.item.count_trx | numFormat("0,0")
        }}</template>
        <template v-slot:cell(principal_sum)="data">{{
          data.item.principal_sum | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(interest_repaid_sum)="data">{{
          data.item.interest_repaid_sum | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(total_repayment_sum)="data">{{
          data.item.total_repayment_sum | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(interest_after_tax_sum)="data">{{
          data.item.interest_after_tax_sum | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(principal_plus_interest_after_cof)="data">{{
          (data.item.principal_sum + data.item.interest_after_tax_sum) | numFormat("0,0.00")
        }}</template>
        <template v-slot:custom-foot>
          <b-tr>
            <b-th colspan="2" class="text-center"
              ><span class="">TOTAL</span></b-th
            >
            <b-th class="text-right"
              ><span class="text-right">{{
                tblData.count_trx | numFormat("0,0")
              }}</span></b-th
            >
            <b-th class="text-right"
              ><span class="text-right">{{
                tblData.principal | numFormat("0,0.00")
              }}</span></b-th
            >
            <b-th class="text-right"
              ><span class="text-right">{{
                tblData.interest_repaid | numFormat("0,0.00")
              }}</span></b-th
            >
            <b-th class="text-right"
              ><span class="text-right">{{
                tblData.total_repayment | numFormat("0,0.00")
              }}</span></b-th
            >
            <b-th class="text-right"
              ><span class="text-right">{{
                tblData.interest_repaid_aftertax | numFormat("0,0.00")
              }}</span></b-th
            >
          </b-tr>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import repayment from "../../apis/repayment";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isLoading: false,
      isBusy: false,
      projectsFilt:[{
        value:'',text:'-- ALL --'
      }],
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "repayment_date",
        sortDesc: false,
        tgl1: moment().startOf("M").format("YYYY-MM-DD"),
        tgl2: moment().format("YYYY-MM-DD"),
        partnerTransactionId: "",
        loan_id: "",
        total_repayment: 0,
        principal: 0,
        interest_repaid: 0,pjxkey:''
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus,
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "repayment_date",
          label: "Repayment Date",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "count_trx",
          label: "Count Trx.",
          thClass: "text-center",
          thStyle: "min-width:100px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "principal_sum",
          label: "Principal (A)",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "interest_repaid_sum",
          label: "Interest Repaid (B)",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "total_repayment_sum",
          label: "Total Repayment (A+B)",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "interest_after_tax_sum",
          label: "Interest After Tax (C)",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "principal_plus_interest_after_cof",
          label: "Principak + Interest After Tax (A+C)",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "nomor",
          label: "No. Trx Bank",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "pjxconcat",
          label: "Project",
          thClass: "text-center",
          tdClass: "text-left",
          tdStyle: "margin-right:10px",
          sortable: true
        },
      ];
      return fields;
    },
  },
  async created() {
    const [projects] = await Promise.all([crud.list({
      tablename: 'project',
      page: 1,
      limit: 10000,
      total: 0,
      sortBy: 'pjxname',
      sortDesc: false,
    })]);

    projects.forEach(tp => {
      this.projectsFilt.push({ value: tp.pjxkey, text: tp.pjxname })
    });
  },
  methods: {
    rowDblClicked(record, index) {
      const route = this.$router.resolve({
        name: "transaction.repayment",
        query: {
          tgl1: moment(record.repayment_date).format("YYYY-MM-DD"),
          tgl2: moment(record.repayment_date).format("YYYY-MM-DD"),
        },
      });
      window.open(route.href, "_blank");
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    async data() {
      try {
        this.isBusy = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.debiturList) {
          this.tblData[key] = filter.debiturList[key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        if (this.tblData.tgl1 || this.tblData.tgl2) {
          if ((this.tblData.tgl2 || "") == "") {
            this.tblData.tgl2 = this.tblData.tgl1;
          }
        }

        const list = await repayment.report(this.tblData);
        console.log('list',list)
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async posting() {
      try {
        this.isLoading = true;
        if (!this.model) {
          this.isLoading = false;
          toastr.warn('Please select a row that want to be POSTING!');
          return;
        }
        await repayment.posting(this.model);
        this.refresh()
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async exportxls() {
      try {
        this.isLoading = true;
        await repayment.exportreportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData = {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tableKey",
        sortDesc: false,
        tablename: "repaymentupload",
        customQuery: "",
        tgl1: "",
        tgl2: "",
        partnerTransactionId: "",
        loan_id: "",
      };
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    },
  },
};
</script>